import { AccountTransactionTypeEnum } from './account-transaction-type.enum';


export class PartnerCodeTransaction {
  private _transactionTime: Date;
  private _type: AccountTransactionTypeEnum;
  private _amount: number;
  private _orderRef: string;

  constructor(
    transactionTimer?: Date,
    type?: AccountTransactionTypeEnum,
    amount?: number,
    orderRef?: string,
  ) {
    this._transactionTime = transactionTimer;
    this._type = type;
    this._amount = amount;
    this._orderRef = orderRef;
  }

  static createFromAny(object: any): PartnerCodeTransaction {
    if (object === null || object === undefined) {
      return null;
    }

    const rfidCardTransaction = new PartnerCodeTransaction();

    rfidCardTransaction._transactionTime = new Date(object.transactionTime);
    rfidCardTransaction._amount = object.amount;
    rfidCardTransaction._orderRef = object.orderRef;
    rfidCardTransaction._type = AccountTransactionTypeEnum.Credit === object.type
      ? AccountTransactionTypeEnum.Credit : AccountTransactionTypeEnum.Debit;

    return rfidCardTransaction;
  }


  get transactionTime(): Date {
    return this._transactionTime;
  }

  get amount(): number {
    return this._amount;
  }

  get type(): AccountTransactionTypeEnum {
    return this._type;
  }

  get orderRef(): string {
    return this._orderRef;
  }

}
